import { createContext } from 'react';
import { PERIOD_TO_RANGE } from './hooks/useDashboardData';

export const DEFAULT_PERIOD = '6m';

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

export const ReportFiltersContext = createContext(null);

export function defaultDateWindow() {
    const r = PERIOD_TO_RANGE[DEFAULT_PERIOD]();
    return { period: DEFAULT_PERIOD, startDate: r.start, endDate: r.end };
}

export function restoreDateWindow(saved) {
    const fn = saved && PERIOD_TO_RANGE[saved.period];
    if (fn) {
        const r = fn();
        return { period: saved.period, startDate: r.start, endDate: r.end };
    }
    if (saved && saved.period === '' && ISO_DATE.test(saved.startDate) && ISO_DATE.test(saved.endDate) && saved.startDate <= saved.endDate) {
        return { period: '', startDate: saved.startDate, endDate: saved.endDate };
    }
    return defaultDateWindow();
}

export function restoreFilterContexts(saved, allowedTypes) {
    if (!saved || !Array.isArray(saved.filters)) return [];
    const seen = new Set();
    return saved.filters
        .filter((c) => {
            if (!c || !allowedTypes.includes(c.type)) return false;
            if (typeof c.value !== 'string' && typeof c.value !== 'number') return false;
            const key = `${c.type}|${c.value}`;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        })
        .map((c) => ({ type: c.type, value: c.value }));
}

export function restoreTab(saved, allowedTabIds) {
    const tab = saved && saved.tab;
    if (!tab || !allowedTabIds.has(tab.id) || typeof tab.label !== 'string') return null;
    return { id: tab.id, label: tab.label };
}

export function serialiseReportFilters({ tab, filters, period, startDate, endDate, excludeDisabled }) {
    return {
        tab: tab ? { id: tab.id, label: tab.label } : null,
        filters,
        period,
        ...(period === '' ? { startDate, endDate } : {}),
        excludeDisabled: Boolean(excludeDisabled),
    };
}
